import { useState } from "react";

const ReciterMenu=()=>{
    const [selectedReciter, setSelectedReciter] = useState(localStorage.getItem('reciterSettings') || "12");

    const reciters = [
        { id: 1, value: "Abdul_Basit_Mujawwad_128kbps", label: "AbdulBasit (Mujawwad)" },
        { id: 2, value: "Abdul_Basit_Murattal_192kbps", label: "AbdulBasit (Murattal)" },
        { id: 3, value: "Abdullah_Basfar_192kbps", label: "Abdullah Basfar" },
        { id: 4, value: "Abdurrahmaan_As-Sudais_192kbps", label: "Abdurrahmaan As-Sudais" },
        { id: 5, value: "Hudhaify_128kbps", label: "Al-Hudhaify" },
        { id: 6, value: "Husary_128kbps_Mujawwad", label: "Al-Husary (Mujawwad)" },
        { id: 7, value: "Minshawy_Mujawwad_192kbps", label: "Al-Minshawy (Mujawwad)" },
        { id: 8, value: "Minshawy_Murattal_128kbps", label: "Al-Minshawy (Murattal)" },
        { id: 9, value: "Abu_Bakr_Ash-Shaatree_128kbps", label: "Ash-Shaatree" },
        { id: 10, value: "Saood_ash-Shuraym_128kbps", label: "Ash-Shuraym" },
        { id: 11, value: "Hani_Rifai_192kbps", label: "Hani Rifai" },
        { id: 12, value: "Alafasy_128kbps", label: "Mishary Rashid Al-Afasy" },
        { id: 13, value: "Muhammad_Jibreel_128kbps", label: "Muhammad Jibreel (128 kbps)" },
        { id: 14, value: "Muhammad_Jibreel_64kbps", label: "Muhammad Jibreel (64 kbps)" },
        { id: 15, value: "ahmed_ibn_ali_al_ajamy_128kbps", label: "Ahmed Ibn Ali Al-Ajamy" },
        { id: 16, value: "Ali_Jaber_64kbps", label: "Ali Jaber" },
        { id: 17, value: "Muhsin_Al_Qasim_192kbps", label: "Muhsin Al Qasim" },
        { id: 18, value: "Nasser_Alqatami_128kbps", label: "Nasser Alqatami" },
        { id: 19, value: "Fares_Abbad_64kbps", label: "Fares Abbad" },
        { id: 20, value: "Abdullaah_3awwaad_Al-Juhaynee_128kbps", label: "Abdullaah Awwaad Al-Juhaynee" },
    ];

    const changeReciter=(reciterId,reciterCode)=>{
        localStorage.setItem('reciterSettings',reciterId);
        localStorage.setItem('selectedReciterCode',reciterCode);
        setSelectedReciter(reciterId);
    }

    return(
        <div className="flex flex-col h-full overflow-y-auto">
            <h4 className="text-white my-6">Reciters</h4>
            <ul className="p-3 space-y-3 text-sm text-gray-700 dark:text-gray-200">
                {reciters.map((reciter) => (
                <li key={reciter.id}>
                    <div className="flex items-center">
                        <input
                            id={`reciter-radio-${reciter.id}`}
                            type="radio"
                            value={reciter.value}
                            name="reciter-radio"
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                            onChange={()=>{
                                changeReciter(reciter.id,reciter.value);
                            }}
                            checked={Number(selectedReciter)===reciter.id}
                        />
                        <label
                            htmlFor={`reciter-radio-${reciter.id}`}
                            className="ml-2 text-sm font-medium text-white"
                        >
                            {reciter.label}
                        </label>
                    </div>
                </li>
                ))}
                <li className="h-44 md:h-0"></li>
            </ul>
        </div>
    );
}

export default ReciterMenu;